import React from 'react';

export function EventCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl shadow-soft-sm border border-gray-100 overflow-hidden">
      {/* Image skeleton */}
      <div className="aspect-[16/10] skeleton" />

      {/* Content skeleton */}
      <div className="p-4">
        {/* Time placeholder */}
        <div className="flex items-center gap-2 mb-2">
          <div className="w-1.5 h-1.5 rounded-full skeleton" />
          <div className="h-3.5 w-20 skeleton rounded-md" />
        </div>

        {/* Title placeholder */}
        <div className="h-5 w-full skeleton rounded-md mb-1.5" />
        <div className="h-5 w-3/4 skeleton rounded-md mb-3" />

        {/* Location placeholder */}
        <div className="flex items-center gap-1.5 mb-3">
          <div className="w-4 h-4 skeleton rounded" />
          <div className="h-3.5 w-32 skeleton rounded-md" />
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between pt-2 border-t border-surface-100">
          {/* Avatars placeholder */}
          <div className="flex items-center">
            <div className="flex -space-x-2">
              <div className="w-7 h-7 rounded-full skeleton border-2 border-white" />
              <div className="w-7 h-7 rounded-full skeleton border-2 border-white" />
              <div className="w-7 h-7 rounded-full skeleton border-2 border-white" />
            </div>
            <div className="ml-2 h-3.5 w-16 skeleton rounded-md" />
          </div>

          {/* Save button placeholder */}
          <div className="w-8 h-8 skeleton rounded-lg" />
        </div>
      </div>
    </div>
  );
}

export function EventGridSkeleton({ count = 6 }) {
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6"
      aria-busy="true"
      aria-label="Loading events"
    >
      {[...Array(count)].map((_, i) => (
        <EventCardSkeleton key={i} />
      ))}
    </div>
  );
}

export default EventCardSkeleton;
